import { ACTIVITY_STATES } from 'constants/enums'
import { get } from 'lodash'
import { createGroupActivities } from 'helpers/selectors'

const groupActivities = createGroupActivities()

export default function(awards, addingToSection) {
  const majorActivityNeeded = get(awards, 'data.majorActivityNeeded')
  const activities = get(awards, 'data.activities')
  const grouped = groupActivities(activities)

  const nonMajors =
    grouped &&
    Object.keys(grouped).filter(section =>
      grouped[section].some(
        activity =>
          !activity.isMajor &&
          activity.activityState.value !== ACTIVITY_STATES.setup.id
      )
    )

  return (
    majorActivityNeeded &&
    Object.keys(grouped).length - nonMajors.length === 1 &&
    !nonMajors.includes(addingToSection)
  )
}
